import z from 'zod/v4'
import { contactLanguageSchema } from '../contacts/types.ts'

export const adminImportFeedbackRequestsCsvSchema = z.object({
  userId: z.uuid(),
  csvContent: z.string().min(1),
})

export const adminBulkImportInvalidContactReasonSchema = z.enum([
  'MISSING_NAME',
  'MISSING_CONTACT_INFO',
  'INVALID_PHONE',
  'INVALID_EMAIL',
  'INVALID_LANGUAGE',
])

export const adminBulkImportInvalidContactSchema = z.object({
  rowNumber: z.number().int().positive(),
  name: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().optional(),
  language: z.string().optional(),
  reason: adminBulkImportInvalidContactReasonSchema,
})

export const adminBulkFeedbackImportRowSchema = z.object({
  rowNumber: z.number().int().positive(),
  name: z.string().min(1),
  phone: z.string().min(1).optional(),
  email: z.email().optional(),
  notes: z.string().optional(),
  language: contactLanguageSchema.optional(),
  followUpEnabled: z.boolean().optional(),
})

export const adminImportFeedbackRequestsCsvResultSchema = z.object({
  contactsCreated: z.number().int().nonnegative(),
  contactsSkipped: z.number().int().nonnegative(),
  feedbackRequestsCreated: z.number().int().nonnegative(),
  feedbackRequestsSkipped: z.number().int().nonnegative(),
  invalidContacts: z.array(adminBulkImportInvalidContactSchema),
})

export type AdminImportFeedbackRequestsCsvInput = z.infer<
  typeof adminImportFeedbackRequestsCsvSchema
>
export type AdminBulkImportInvalidContact = z.infer<typeof adminBulkImportInvalidContactSchema>
export type AdminBulkImportInvalidContactReason = z.infer<
  typeof adminBulkImportInvalidContactReasonSchema
>
export type AdminBulkFeedbackImportRow = z.infer<typeof adminBulkFeedbackImportRowSchema>
export type AdminImportFeedbackRequestsCsvResult = z.infer<
  typeof adminImportFeedbackRequestsCsvResultSchema
>
